// Lista em rolo -- estilo compartilhado para listas dentro de modal.
//
// O PROBLEMA
// Listas dentro dos modais cresciam sem limite. Com muitos veiculos, muitas
// O.S., muitos itens de orcamento ou um historico longo, o cartao do modal
// esticava, a camada de rolagem do modal ganhava barra e o cartao inteiro
// subia e descia -- a pessoa perdia a referencia de onde estava.
// E nas listas que JA tinham altura maxima havia o outro lado do mesmo
// problema: ao terminar a rolagem da lista, o navegador continuava rolando a
// camada de tras, e o modal "escapava" da tela.
//
// O QUE ESTE ESTILO FAZ
// - maxHeight: a lista rola por dentro e o cartao do modal fica parado;
// - overscrollBehavior "contain": a rolagem morre na lista; nada atras dela
//   se mexe. E o detalhe que segura o modal no lugar;
// - scrollBehavior "smooth": rolagem por teclado/programatica desliza em vez
//   de saltar;
// - maskImage: as pontas somem em degrade, como um rolo de papel que continua
//   alem do que se ve. O degrade de baixo e maior que o de cima de proposito:
//   quem le de cima para baixo precisa do sinal de "tem mais" embaixo, nao de
//   um primeiro item apagado em cima.
//
// POR QUE UM HELPER DE ESTILO E NAO UM COMPONENTE
// Aplicar isto e acrescentar propriedades a divs que em boa parte dos casos ja
// existem. Um componente exigiria reescrever a estrutura JSX de varias telas
// em producao -- risco desproporcional para um ajuste visual. Assim cada lista
// muda so o proprio style e o comportamento e identico em todas.

const TOPO = 6;
const FIM = 30;

const MASCARA =
  "linear-gradient(to bottom, transparent 0, #000 " + TOPO + "px, " +
  "#000 calc(100% - " + FIM + "px), transparent 100%)";

// altura: altura maxima da area visivel (numero em px ou string CSS).
// opcoes.fade: false para caixas que tem borda, sombra ou fundo proprio -- ali
//   o degrade apagaria a borda e a sombra, o que fica pior do que sem ele.
export function rolo(altura, opcoes) {
  const fade = !opcoes || opcoes.fade !== false;
  const base = {
    maxHeight: altura,
    overflowY: "auto",
    overscrollBehavior: "contain",
    scrollBehavior: "smooth",
    // Folga para a barra de rolagem nao encostar no conteudo.
    paddingRight: 2,
    scrollbarWidth: "thin",
  };
  if (!fade) return base;
  return { ...base, maskImage: MASCARA, WebkitMaskImage: MASCARA };
}

export default rolo;
